module.exports = __webpack_public_path__ + "img/sbt-caravanas-logo.9cdd2316.png";